<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <div class="visits-performance">
      <div class="controls">
        <app-select
          [type]="'check'"
          [name]="dictionaryService.get('Products')"
          [options]="productOptions"
          (getCheckedItems)="onProductFilterChange($event)"
        ></app-select>
      </div>

      <app-line-chart
        [data]="chartData"
        [isLoading]="chartLoading"
      ></app-line-chart>
    </div>
  }
</app-tab-layout>
